const getLeadsTrace = (serviceId) => ({
  serviceId,
  consumerId: 'WEBPUB',
  channelCode: 'WEB',
});

const generateTraceId = () => new Date().getTime().toString();

const getBodyAmplify = (data, origen = undefined) => {
  switch (origen) {
    case 'SALUD':
    case 'CANALVIDA':
      return {
        body: {
          payload: data,
        },
      };
    case 'LEAD': {
      const traceResult = getLeadsTrace('api-salud-flexible');
      traceResult.traceId = generateTraceId();
      return {
        body: {
          request: {
            trace: traceResult,
            payload: data,
          },
        },
      };
    }
    case 'PERSON':
      return {
        body: {
          payload: {
            request: {
              trace: getLeadsTrace('API-CANAL'),
              payload: data,
            },
          },
        },
      };
    case 'CORE': {
      const trace = getLeadsTrace('api-validacion-maestros-salud');
      trace.traceId = generateTraceId();
      return {
        body: {
          payload: {
            request: {
              trace,
              payload: data,
            },
          },
        },
      };
    }
    case 'CORE-AMI': {
      const trace = getLeadsTrace('api-cotizar-multicanal-ami');
      trace.traceId = generateTraceId();
      return {
        body: {
          request: {
            trace,
            payload: data,
          },
        },
      };
    }
    case 'SALUD-FLEX': {
      const trace = getLeadsTrace('api-cotizar-multicanal-ami');
      trace.traceId = generateTraceId();
      return {
        request: {
          trace,
          payload: data,
        },
      };
    }
    case 'COTIZACION': {
      const trace = getLeadsTrace('api-cotizar-multicanal-ami');
      trace.traceId = generateTraceId();
      return {
        body: {
          payload: {
            request: {
              trace,
              payload: data,
            },
          },
        },
      };
    }
    default:
      return {
        body: {
          payload: {
            request: data,
          },
        },
      };
  }
};

export default getBodyAmplify;
